module.exports = __webpack_public_path__ + "img/good-garage-scheme.9d9cc139.jpg";